// extracted by mini-css-extract-plugin
export default {"SiteInfoInnerPane":"SiteInfoInnerPane_ktg9j_v17-8-1"};